import z from "zod";
// RouteStatus enum
export var RouteStatus;
(function (RouteStatus) {
    RouteStatus["CREATED"] = "CREATED";
    RouteStatus["PLANNED"] = "PLANNED";
    RouteStatus["NOT_ACCEPTED"] = "NOT_ACCEPTED";
    RouteStatus["IN_PROGRESS"] = "IN_PROGRESS";
    RouteStatus["COMPLETED"] = "COMPLETED";
    RouteStatus["CANCELLED"] = "CANCELLED";
})(RouteStatus || (RouteStatus = {}));
// Zod схема для RouteStatus
export const zRouteStatusSchema = z.enum([
    RouteStatus.PLANNED,
    RouteStatus.IN_PROGRESS,
    RouteStatus.COMPLETED,
    RouteStatus.CANCELLED,
    RouteStatus.CREATED,
    RouteStatus.NOT_ACCEPTED,
]);
// Лейблы для отображения
export const ROUTE_STATUS_LABELS = {
    [RouteStatus.PLANNED]: "Запланирован",
    [RouteStatus.IN_PROGRESS]: "Выполняется",
    [RouteStatus.COMPLETED]: "Завершен",
    [RouteStatus.CANCELLED]: "Отменен",
    [RouteStatus.CREATED]: "Создан",
    [RouteStatus.NOT_ACCEPTED]: "Не принят",
};
export const getRouteStatusLabel = (status) => {
    return ROUTE_STATUS_LABELS[status];
};
// Заказ в маршруте (номер + id для ссылки)
export const zRouteOrderRefSchema = z.object({
    orderNumber: z.string(),
    orderId: z.string(),
});
// RouteSearchView схема для отображения в таблице
export const zRouteSearchViewSchema = z.object({
    routeId: z.string(), // UUID маршрута
    routeStatus: zRouteStatusSchema, // enum RouteStatus
    technicianFullName: z.string().nullable(), // ФИО техника
    ordersCount: z.number(), // Кол-во заказов в маршруте
    orderNumbers: z.array(zRouteOrderRefSchema).nullable().optional(), // Номера заказов с id
    // Начало маршрута (из первой точки - время отбытия)
    plannedStartTime: z.string().nullable(), // Плановое время начала (ISO 8601)
    expectedStartTime: z.string().nullable(), // Ожидаемое время начала (ISO 8601)
    actualStartTime: z.string().nullable(), // Фактическое время начала (ISO 8601)
    // Окончание маршрута (из последней точки - время прибытия)
    plannedEndTime: z.string().nullable(), // Плановое время окончания (ISO 8601)
    expectedEndTime: z.string().nullable(), // Ожидаемое время окончания (ISO 8601)
    actualEndTime: z.string().nullable(), // Фактическое время окончания (ISO 8601)
    // Ресурсы
    serviceVehicleName: z.string().nullable(), // Название служебного ТС
    chargingStationName: z.string().nullable(), // Название зарядной станции
});
